import { render, staticRenderFns } from "./RestockCards.vue?vue&type=template&id=4d9a2426&scoped=true"
import script from "./RestockCards.vue?vue&type=script&lang=js"
export * from "./RestockCards.vue?vue&type=script&lang=js"
import style0 from "./RestockCards.vue?vue&type=style&index=0&id=4d9a2426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a2426",
  null
  
)

export default component.exports